// ============================================================================
// 📁 FILE: src/modules/ticket/components/detail/CountdownRenderer.js
// 📝 PURPOSE:
//    Helper to convert remaining seconds into HH:MM:SS format.
//    Handles negative values (past due).
// ============================================================================

export default function formatSeconds(seconds) {
  if (seconds === null || seconds === undefined) return "-";

  let s = Number(seconds);

  // Define if overdue
  const overdue = s < 0;
  s = Math.abs(s);

  const hours = Math.floor(s / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  const secs = s % 60;

  const pad = (v) => String(v).padStart(2, "0");

  const output = `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
  return overdue ? `- ${output}` : output;
}
